import { apiWrapper } from "@/services/api";
import store from "@/store/index";

// 変更すると該当のidの特急券の内容が変わるのではなく、新たなidの特急券が生成される
// 既存のidの特急券は「無効」(ticketing_status:05)になる
export const postChangeMyTicket = async (params) => {
  let response;
  try {
    response = await apiWrapper(
      "POST",
      `/mfitt/change_limited_express_tickets`,
      params
    );
    console.log("postBookingOrPurchase response.data :>> ", response.data);
    // 購入完了画面で使用するため、response.dataをstoreに格納
    store.commit("MFITT/setMyLimitedExpressTicket", response.data);
  } catch (err) {
    console.log('ERROR"" postChangeMyTicket():', err);
    throw err;
  }
  return response.data;
};
